/** Категории соответствия из MVP_PRD §19. */
export type MatchCategory = 'very_high' | 'good' | 'partial' | 'weak';

export function matchCategory(score: number): MatchCategory {
  if (score >= 85) return 'very_high';
  if (score >= 70) return 'good';
  if (score >= 55) return 'partial';
  return 'weak';
}
